var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.62119 3.70145C9.34961 3.42682 8.9071 3.42336 8.63126 3.69373L3.45709 8.80755L1.20783 6.47901C0.939559 6.1994 0.495432 6.19023 0.215859 6.45849C-0.0637446 6.72676 -0.0729219 7.17089 0.195347 7.45046C0.196562 7.45171 0.197748 7.45295 0.198963 7.4542L2.94146 10.2963C3.0727 10.4302 3.25209 10.506 3.43958 10.5068H3.4473C3.63124 10.5062 3.80762 10.4334 3.93841 10.304L9.61487 4.69138C9.88913 4.4194 9.89192 3.97692 9.62119 3.70145Z",
    fill: "#027CBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15097 10.2963C7.28188 10.4298 7.46069 10.5056 7.6477 10.5068H7.65542C7.83936 10.5062 8.01573 10.4334 8.14653 10.304L13.823 4.69136C14.0803 4.40164 14.054 3.95821 13.7643 3.70091C13.5017 3.46765 13.107 3.46458 12.8408 3.69371L7.66873 8.80753L7.48421 8.616C7.21597 8.33639 6.77185 8.32718 6.49224 8.59545C6.21264 8.86369 6.20343 9.30782 6.4717 9.58742C6.47291 9.5887 6.47413 9.58994 6.47535 9.59119L7.15097 10.2963Z",
    fill: "#027CBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleTick);
export default __webpack_public_path__ + "static/media/doubleTick.64ddb5ef5dd27bd3d541be3dd2f71121.svg";
export { ForwardRef as ReactComponent };